"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_gateway_client_request_1 = require("./../../../services/gateway-control/base-gateway-client-request");
/**
 * Base type for GATEWAY_CLIENT_REQUEST requests targeted at services.
 */
var BaseGatewayServiceRequest = /** @class */ (function (_super) {
    __extends(BaseGatewayServiceRequest, _super);
    /**
     * Create a new BaseGatewayClientRequest instance
     *
     * @param sessionId  the gateway session identifier
     */
    function BaseGatewayServiceRequest(sessionId, serviceId) {
        var _this = _super.call(this, sessionId) || this;
        _this.serviceId = serviceId;
        return _this;
    }
    return BaseGatewayServiceRequest;
}(base_gateway_client_request_1.BaseGatewayClientRequest));
exports.BaseGatewayServiceRequest = BaseGatewayServiceRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/services/base-gateway-service-request.js
// module id = 148
// module chunks = 1